import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  :root {
    --primary: ${p => p.theme.colors.primary};
    --primary-transparent: ${p => p.theme.colors.primaryTransparent};
    --danger: ${p => p.theme.colors.danger};
    --danger-transparent: ${p => p.theme.colors.dangerTransparent};
    --success: ${p => p.theme.colors.success};
    --success-transparent: ${p => p.theme.colors.successTransparent};
    --warning: ${p => p.theme.colors.warning};
    --warning-transparent: ${p => p.theme.colors.warningTransparent};
    --info: ${p => p.theme.colors.info};
    --info-transparent: ${p => p.theme.colors.infoTransparent};

    --black-transparent: ${p => p.theme.colors.blackTransparent};

    --white: ${p => p.theme.colors.white};
    --white-dark: ${p => p.theme.colors.whiteDark};
    --white-darker: ${p => p.theme.colors.whiteDarker};

    --gray-e: ${p => p.theme.colors.grayE}; //navbar border
    --gray-d: ${p => p.theme.colors.grayD}; //input border
    --gray-c: ${p => p.theme.colors.grayC}; //input border
    --gray-9: ${p => p.theme.colors.gray9}; //input border

    --black-2: ${p => p.theme.colors.black2};
    --black-3: ${p => p.theme.colors.black3};
    --black-5: ${p => p.theme.colors.black5};
    --black-7: ${p => p.theme.colors.black7};
  }

  ::-webkit-scrollbar {
    width: 15px;
    height: 15px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 0px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(218, 220, 224);
    background-clip: padding-box;
    border-image: initial;
    border-style: solid;
    border-color: transparent;
    border-width: 4px;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-button {
    height: 0px;
    width: 0px;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  ::placeholder {
    color: #aaa;
    opacity: 1;
  }

  * {
    font-family: 'Red Hat Display', sans-serif;
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    display: flex;
    flex-direction: column;
    background: var(--white-dark);
  }

  a {
    font-weight: 600;
    color: var(--primary);
    text-decoration: none;
    transition: 0.4s opacity;
  }

  hr {
    border-top: 1px solid var(--gray-e);
    margin: 24px 0;
  }

  .spin {
    animation: 1s spinKeyframes linear infinite;

    @keyframes spinKeyframes {
      to {
        transform: rotate(360deg);
      }
    }
  }
`;

export default GlobalStyle;
